import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * @customElement anmeldung-component-footer
 */
@customElement('anmeldung-component-footer')
export class AnmeldungComponentFooter extends ChemistryLitElement {
  @property({ attribute: false }) public schoolLevel = 'us';
  @property({ type: Boolean, attribute: 'show-required' }) required = false;

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          paddingBottom: this.spacing.md,
        },
      },
    ];
  }

  override render() {
    return html`
      <cr-flex h100 center crossaxis-center space="lg">
        ${this.required
          ? html`<cr-text ${css({ fontSize: '13px' })}>mit * gekennzeichnete Felder sind Pflichtfelder.</cr-text>`
          : nothing}
        <cr-flex space="sm" center>
          <cr-text ${css({ textAlign: 'center' })}>
            Bei Fragen oder Problemen wenden Sie sich an
            <cr-link href="mailto:verwaltung@chancenwerk.org"> verwaltung@chancenwerk.org </cr-link>
          </cr-text>
        </cr-flex>
        <cr-flex space="sm" center>
          <cr-text ${css({ textAlign: 'center' })}>
            Informationen zur Verarbeitung der personenbezogenen Daten im Rahmen des Lernförderangebots und dessen
            Evaluation finden Sie unter:
          </cr-text>
          <cr-text ${css({ textAlign: 'center' })}>
            <cr-link
              href="${this.schoolLevel === 'us'
                ? 'https://chancenwerk.de/datenschutzinformation/n8e26s/'
                : 'https://chancenwerk.de/datenschutzinformation/d4a83m/'}"
              target="_blank"
              ${css({ wordBreak: 'break-All' })}
            >
              ${this.schoolLevel === 'us'
                ? 'https://chancenwerk.de/datenschutzinformation/n8e26s/'
                : 'https://chancenwerk.de/datenschutzinformation/d4a83m/'}
            </cr-link>
          </cr-text>
        </cr-flex>
      </cr-flex>
    `;
  }
}
